import { useAuthContext } from '../contexts/authContext.js';
export const useAuth = () => {
    return useAuthContext();
};
